import { Component, OnInit } from '@angular/core';
import { LoginService } from 'src/app/Common/Services/login.service';
import { MatDialog } from '@angular/material';
import { LoginComponent } from '../login/login.component';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-faq-motor-insurance',
  templateUrl: './faq-motor-insurance.component.html',
  styleUrls: ['./faq-motor-insurance.component.css']
})
export class FaqMotorInsuranceComponent implements OnInit {

  selected = 'ENG';
  product:any;
  motorlist:any;
  code1 :any;
  faqd1 :any;
  faqs1 :any;
  code2 :any;
  faqd2 :any;
  faqs2 :any;
  code3 :any;
  faqd3 :any;
  faqs3 :any;
  faqsd3 :any;
  faql3 :any;
  faqld3 :any;
  faqv3  :any;
  faqf3  :any;
  faqfl3  :any;
  faqfle3 :any;
  faqflex3 :any;
  code4 :any;
  faqd4 :any;
  faqs4:any;
  code5 :any;
  faqd5 :any;
  faqs5:any;
  faqsd5:any;
  faql5 :any;
  faqld5:any;
  faqv5 :any;
  faqf5:any;
  code6 :any;
  faqd6 :any;
  faqs6:any;
  faqsd6:any;
  faql6 :any;
  faqld6:any;
  code7 :any;
  faqd7 :any;
  faqs7:any;
  faqsd7:any;
  faql7:any;
  faqld7:any;
  code8 :any;
  faqd8 :any;
  faqs8:any;
  faqsd8:any;
  faql8:any;
  faqld8:any;
  faqv8 :any;
  code9 :any;
  faqd9 :any;
  faqs9:any;
  faqsd9:any;
  faql9:any;
  faqld9:any;
  faqv9  :any;
  faqf9 :any;
  code10 :any;
  faqd10 :any;
  faqs10:any;
  faqsd10:any;
  code11 :any;
  faqd11 :any;
  faql11 :any;
  faqld11:any;
  faqv11  :any;
  faqf11:any;
  faqfl11 :any;
  faqfle11:any;
  faqflex11:any;
  
  constructor(public loginservice:LoginService,private toastr: ToastrService,public dialog: MatDialog,private router:Router,private route:ActivatedRoute) {


   }

   ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.product = params["product"];     
    });

    var product = this.product;
    this.loginservice.getfaqlist(product).subscribe((res:any) => {
      if(res.responseBody != undefined){
        
        console.log("Motor FAQ Listing :", res.responseBody.faqdesc);
        this.motorlist = res.responseBody.faqdesc;
          
          for(let i =0; i < this.motorlist.length;i++){
            if(this.motorlist[i].PC_CODE == "01"){
              this.code1 =this.motorlist[i].PC_CODE;
              this.faqd1 = this.motorlist[i].PC_DESC_BL;
              this.faqs1 = this.motorlist[i].PC_SHORT_DESC;
            }else if (this.motorlist[i].PC_CODE== "02"){
              this.code2 =this.motorlist[i].PC_CODE;
              this.faqd2 = this.motorlist[i].PC_DESC_BL;
              this.faqs2 = this.motorlist[i].PC_SHORT_DESC;
            }else if (this.motorlist[i].PC_CODE == "03"){
              this.code3 =this.motorlist[i].PC_CODE;
              this.faqd3 = this.motorlist[i].PC_DESC_BL;
              this.faqs3= this.motorlist[i].PC_SHORT_DESC;
              this.faqsd3 = this.motorlist[i].PC_SHORT_DESC_BL;
              this.faql3 = this.motorlist[i].PC_LONG_DESC;
              this.faqld3 = this.motorlist[i].PC_LONG_DESC_BL;
              this.faqv3 = this.motorlist[i]. PC_VALUE;
              this.faqf3= this.motorlist[i].PC_FLEX_01;
              this.faqfl3 = this.motorlist[i].PC_FLEX_02;
              this.faqfle3 = this.motorlist[i].PC_FLEX_03;
              this.faqflex3 = this.motorlist[i].PC_FLEX_04;
            }else if (this.motorlist[i].PC_CODE == "04"){
              this.code4 =this.motorlist[i].PC_CODE;
              this.faqd4 = this.motorlist[i].PC_DESC_BL;
              this.faqs4= this.motorlist[i].PC_SHORT_DESC;
            }else if (this.motorlist[i].PC_CODE == "05"){
              this.code5 =this.motorlist[i].PC_CODE;
              this.faqd5 = this.motorlist[i].PC_DESC_BL;
              this.faqs5= this.motorlist[i].PC_SHORT_DESC;
              this.faqsd5 = this.motorlist[i].PC_SHORT_DESC_BL;
              this.faql5 = this.motorlist[i].PC_LONG_DESC;
              this.faqld5 = this.motorlist[i].PC_LONG_DESC_BL;
              this.faqv5= this.motorlist[i].PC_VALUE;
              this.faqf5= this.motorlist[i].PC_FLEX_01;
            }else if (this.motorlist[i].PC_CODE == "06"){
              this.code6 =this.motorlist[i].PC_CODE;
              this.faqd6 = this.motorlist[i].PC_DESC_BL;
              this.faqs6= this.motorlist[i].PC_SHORT_DESC;
              this.faqsd6 = this.motorlist[i].PC_SHORT_DESC_BL;
              this.faql6 = this.motorlist[i].PC_LONG_DESC;
              this.faqld6 = this.motorlist[i].PC_LONG_DESC_BL;
            }else if (this.motorlist[i].PC_CODE == "07"){
              this.code7 =this.motorlist[i].PC_CODE;
              this.faqd7 = this.motorlist[i].PC_DESC_BL;
              this.faqs7= this.motorlist[i].PC_SHORT_DESC;
              this.faqsd7 = this.motorlist[i].PC_SHORT_DESC_BL;
              this.faql7= this.motorlist[i].PC_LONG_DESC;
            }else if (this.motorlist[i].PC_CODE == "08"){
              this.code8 =this.motorlist[i].PC_CODE;
              this.faqd8 = this.motorlist[i].PC_DESC_BL;
              this.faqs8= this.motorlist[i].PC_SHORT_DESC;
              this.faqsd8 = this.motorlist[i].PC_SHORT_DESC_BL;
              this.faql8= this.motorlist[i].PC_LONG_DESC;
              this.faqld8 = this.motorlist[i].PC_LONG_DESC_BL;
              this.faqv8= this.motorlist[i]. PC_VALUE;
            }else if (this.motorlist[i].PC_CODE == "09"){
              this.code9 =this.motorlist[i].PC_CODE;
              this.faqd9 = this.motorlist[i].PC_DESC_BL;
              this.faqs9= this.motorlist[i].PC_SHORT_DESC;
              this.faqsd9 = this.motorlist[i].PC_SHORT_DESC_BL;
              this.faql9= this.motorlist[i].PC_LONG_DESC;
              this.faqld9 = this.motorlist[i].PC_LONG_DESC_BL;
              this.faqv9 = this.motorlist[i]. PC_VALUE;
              this.faqf9 = this.motorlist[i].PC_FLEX_01;
            }else if (this.motorlist[i].PC_CODE == "10"){
              this.code10 =this.motorlist[i].PC_CODE;
              this.faqd10 = this.motorlist[i].PC_DESC_BL;
              this.faqs10= this.motorlist[i].PC_SHORT_DESC;
              this.faqsd10 = this.motorlist[i].PC_SHORT_DESC_BL;
           }else if (this.motorlist[i].PC_CODE == "11"){
              this.code11 =this.motorlist[i].PC_CODE;
              this.faqd11 = this.motorlist[i].PC_DESC_BL;
              this.faql11 = this.motorlist[i].PC_LONG_DESC;
              this.faqld11 = this.motorlist[i].PC_LONG_DESC_BL;
              this.faqv11 = this.motorlist[i]. PC_VALUE;
              this.faqf11= this.motorlist[i].PC_FLEX_01;
              this.faqfl11 = this.motorlist[i].PC_FLEX_02;
              this.faqfle11 = this.motorlist[i].PC_FLEX_03;
              this.faqflex11 = this.motorlist[i].PC_FLEX_04;            }
          }
      }
    }) 
  }
  goBack() {
    window.history.back();
  }
  contactclick(){
    this.router.navigate(["/contactUs"])
  }
   openLoginDialog(): void {
    const dialogRef = this.dialog.open(LoginComponent, {
        panelClass: 'loginpopupbox'
    });
  }


  


}


